// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #161618;
  height: 100%;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

:root {
  --color-primary-black: #131117;
  --color-primary-white: #ffffff;
  --color-primary-blue: #3870FF;
  --color-primary-violet: #B000EB;
  --color-text-blue: #004DE8;
  --color-secondary-gray: #A7A7A7;
  --color-card-bg: rgba(83, 80, 80, 0.5);
  --color-danger: #FF445A;
  --color-success: #03ff03;
  --color-orange: #EF8800;
  --color-secondary-black: #19171D;
  --color-card-define: #133D4E;
  --color-card-assets: #22370D;
  --color-card-explore: #35258E;
  --color-card-import: #38014B;

  --text-large: 56px;
  --text-semi-large: 40px;
  --text-small: 18px;
  --text-semi-small: 14px;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE;aACW;AACb;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,6BAA6B;EAC7B,+BAA+B;EAC/B,0BAA0B;EAC1B,+BAA+B;EAC/B,sCAAsC;EACtC,uBAAuB;EACvB,wBAAwB;EACxB,uBAAuB;EACvB,gCAAgC;EAChC,4BAA4B;EAC5B,4BAA4B;EAC5B,6BAA6B;EAC7B,4BAA4B;;EAE5B,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,uBAAuB;AACzB","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: #161618;\n  height: 100%;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n:root {\n  --color-primary-black: #131117;\n  --color-primary-white: #ffffff;\n  --color-primary-blue: #3870FF;\n  --color-primary-violet: #B000EB;\n  --color-text-blue: #004DE8;\n  --color-secondary-gray: #A7A7A7;\n  --color-card-bg: rgba(83, 80, 80, 0.5);\n  --color-danger: #FF445A;\n  --color-success: #03ff03;\n  --color-orange: #EF8800;\n  --color-secondary-black: #19171D;\n  --color-card-define: #133D4E;\n  --color-card-assets: #22370D;\n  --color-card-explore: #35258E;\n  --color-card-import: #38014B;\n\n  --text-large: 56px;\n  --text-semi-large: 40px;\n  --text-small: 18px;\n  --text-semi-small: 14px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
